import React from 'react';

type Props = {
  htmlContent: string;
};

const HtmlToPlainText: React.FC<Props> = ({ htmlContent }) => {
  const plainText = htmlContent
    ?.replace(/<p>/g, '') // remove opening <p>
    ?.replace(/<\/p>/g, '\n') // replace closing </p> with line break
    ?.replace(/<[^>]+>/g, ''); // remove any other HTML tags if present

  return (
    <div className='whitespace-pre-line text-base text-gray-800'>
      {plainText}
    </div>
  );
};

export default HtmlToPlainText;

export const CleanFormattedText = ({ content }: { content: any }) => {
  // Replace HTML <p> tags and line breaks
  const plainText = content
    ?.replace(/<p>/gi, '') // remove <p>
    ?.replace(/<\/p>/gi, '\n') // replace </p> with newline
    ?.replace(/\/n|\\n/g, '\n') // handle /n or \n as newline
    ?.replace(/<[^>]+>/g, ''); // strip remaining HTML tags

  return (
    <div className='whitespace-pre-line text-base text-gray-800'>
      {plainText}
    </div>
  );
};
